import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { HOST, ACCOUNTS_URI, USER_URI, PROFILE_URI, UPDATE_URI, APP_KEY } from 'variables';

// Define thunk action creators
const GET_ACC_URL = `${HOST}/act/org/accounts/${APP_KEY}/getuserinfo`;
const COLOR_SCHEME_URL = HOST + ACCOUNTS_URI + USER_URI + 'colorScheme';
const UPDATE_ACC_URL = `${HOST}/act/org/accounts/${APP_KEY}/updateaccountinfo`;

export const getProfile = createAsyncThunk('profile/getProfile', async ({ headers }) => {
  const response = await axios.post(
    `${GET_ACC_URL}`,
    {},
    {
      headers
    }
  );

  const data = await response?.data?.data?.[0];

  return data;
});

export const setColorScheme = createAsyncThunk('profile/setColorScheme', async ({ accData, headers }, { dispatch, getState }) => {
  const response = await axios.post(COLOR_SCHEME_URL, accData, { headers: headers });

  const data = await response.data;

  return data;
});

export const updateProfile = createAsyncThunk('profile/updateProfile', async ({ headers, editedData }, { dispatch, getState }) => {
  const response = await axios.post(`${UPDATE_ACC_URL}`, editedData, { headers });

  const data = await response.data;

  return data;
});

const profile = createSlice({
  name: 'profile',
  initialState: {
    isLoading: true,
    profile: null,
    error: null,
    success: false,
    isError: false,
    errorMessage: '',
    isUpdating: false,
    isUpdated: false,
    isDeleting: false,
    isDeleted: false
  },
  reducers: {
    resetProfile: () => null,
    resetUpdateStatus: (state) => {
      state.isUpdating = false;
      state.isUpdated = false;
      state.isError = false;
      state.errorMessage = '';
    },
    newProfile: {
      reducer: (state, action) => {
        state.profile = action.payload;
        state.isLoading = false;
        state.error = null;
        state.success = true;
      },
      prepare: (event) => ({
        payload: {
          first_name: '',
          last_name: '',
          email_address: '',
          contact_number: ''
        }
      })
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProfile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.profile = action.payload;
        state.error = null;
        state.success = true;
      })
      .addCase(getProfile.pending, (state, action) => {
        state.isLoading = true;
        state.profile = null;
        state.error = null;
        state.success = false;
      })
      .addCase(getProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(setColorScheme.fulfilled, (state, action) => {
        state.isUpdating = false;
        state.isUpdated = true;
        state.isError = false;
        state.errorMessage = '';
        state.profile = action.payload;
      })
      .addCase(setColorScheme.pending, (state, action) => {
        state.isUpdating = true;
        state.isUpdated = false;
        state.isError = false;
        state.errorMessage = '';
      })
      .addCase(setColorScheme.rejected, (state, action) => {
        state.isUpdating = false;
        state.isUpdated = false;
        state.isError = true;
        state.errorMessage = action.error.message;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.isUpdating = false;
        state.isUpdated = true;
        state.isError = false;
        state.errorMessage = '';
        // state.profile = action.payload;
      })
      .addCase(updateProfile.pending, (state, action) => {
        state.isUpdating = true;
        state.isUpdated = false;
        state.isError = false;
        state.errorMessage = '';
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.isUpdating = false;
        state.isUpdated = false;
        state.isError = true;
        state.errorMessage = action.error.message;
      });
  }
});

export const { newProfile, resetProfile, resetUpdateStatus } = profile.actions;

export const selectProfile = (state) => state.profile.profile;
export const selectIsUpdating = (state) => state.profile.isUpdating;
export const selectIsCreated = (state) => state.profile.isUpdated;
export const selectIsError = (state) => state.profile.isError;
export const selectErrorMessage = (state) => state.profile.errorMessage;

export default profile.reducer;
